const timelineData = [
  {
    "year": 2012,
    "events": ["CERN announces the discovery of the Higgs boson, confirming the final missing piece of the Standard Model."]
  },
  {
    "year": 1987,
    "events": ["The discovery of high-temperature superconductivity by J. Georg Bednorz and K. Alex Müller."]
  },
  {
    "year": 1974,
    "events": ["The discovery of the charm quark by experiments at SLAC and Brookhaven National Lab consolidates the Standard Model of particle physics."]
  }
  ,
  {
    "year": 1974,
    "events": ["The discovery of the charm quark by experiments at SLAC and Brookhaven National Lab consolidates the Standard Model of particle physics."]
  }, 
  {
    "year": 1964,
    "events": ["Peter Higgs proposes the existence of the Higgs boson."]
  },
  {
    "year": 1954,
    "events": ["Theodore Maiman invents the first practical laser."]
  }, 
  {
    "year": 1947,
    "events": ["John Bardeen, Walter Brattain, and William Shockley invent the transistor."]
  },
  {
    "year": 1938,
    "events": ["Lise Meitner and Otto Hahn discover nuclear fission."]
  },
  {
    "year": 1932,
    "events": ["James Chadwick discovers the neutron, which leads to a deeper understanding of atomic structure."]
  },
  {
    "year": 1927,
    "events": ["Werner Heisenberg formulates the uncertainty principle, stating that certain pairs of physical properties cannot be precisely measured simultaneously."]
  },
  {
    "year": 1924,
    "events": ["Louis de Broglie proposes that particles, like electrons, exhibit both wave-like and particle-like properties."]
  },
  {
    "year": 1915,
    "events": ["Albert Einstein publishes his theory of general relativity, explaining gravity as the warping of space and time."]
  },
  {
    "year": 1911,
    "events": ["Ernest Rutherford discovers the atomic nucleus through the gold foil experiment."]
  },
  {
    "year": 1905,
    "events": ["Albert Einstein publishes his theory of special relativity, including the famous equation E=mc²."]
  },
  {
    "year": 1900,
    "events": ["Max Planck introduces the idea of quantized energy levels, marking the birth of quantum theory."]
  },
  {
    "year": 1897,
    "events": ["J.J. Thomson discovers the electron, the first subatomic particle."]
  },
  {
    "year": 1865,
    "events": ["James Clerk Maxwell publishes his equations that describe electromagnetism, unifying electricity and magnetism into a single theory."]
  },
  {
    "year": 1831,
    "events": ["Michael Faraday demonstrates electromagnetic induction, showing that a changing magnetic field can induce an electric current."]
  },
  {
    "year": 1820,
    "events": ["André-Marie Ampère formulates the relationship between electricity and magnetism, leading to the discovery of electromagnetism."]
  },
  {
    "year": 1800,
    "events": ["Alessandro Volta invents the first chemical battery, the *Voltaic pile*."]
  },
  {
    "year": 1791,
    "events": ["Luigi Galvani discovers bioelectricity through his experiments with frogs' legs."]
  },
  {
    "year": 1687,
    "events": ["Isaac Newton publishes *Philosophiæ Naturalis Principia Mathematica*, laying the foundations for classical mechanics with his laws of motion and the law of universal gravitation."]
  },
  {
    "year": 1609,
    "events": ["Galileo Galilei improves the telescope, providing significant contributions to observational astronomy and the study of motion."]
  }
];

export default timelineData;